import React from 'react';

import { TERMS_AND_CONDITIONS_HTML } from '#/utils';

const TermsAndConditions = () => {
    return (
        <div className='bg-white rounded-lg px-10 py-8 flex flex-col gap-4 '>
            <h1 className='font-cormorant text-[40px] font-semibold text-textPrimary text-center'>
                Terms And Conditions
            </h1>
            <div
                className='h-[calc(100dvh-265px)] overflow-y-auto text-gray500 font-inter text-base font-normal rich-text-content'
                dangerouslySetInnerHTML={{ __html: TERMS_AND_CONDITIONS_HTML }}
            />
        </div>
    );
};

export { TermsAndConditions };
